import { render, staticRenderFns } from "./policy-tables-configure-installation.vue?vue&type=template&id=672976de"
import script from "./policy-tables-configure-installation.vue?vue&type=script&lang=js"
export * from "./policy-tables-configure-installation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports